import { useNavigate } from 'react-router-dom'
import { ICONS } from '../../../common/constants'
import ResourceList from '../../../components/admin/ResourceList'

export default function UserPagesList() {
    const navigate = useNavigate()

    return (
        <>
            <ResourceList
                paginated
                paginationLimit={20}
                getItemsFromResponse={(data) => data?.results}
                apiUrl={'/v1/pages'}
                newItemLabel={'New page'}
                newItemPath={
                    '/all-pages-request-feature?requestFeature=create_pages'
                }
                renderMainButton={true}
                itemClickPath={'/pages/:item.slug'}
                filters={{
                    search: true,
                }}
                fields={[
                    {
                        column: 1,
                        getValue: (item) =>
                            `pages/${item.parentPage ? `${item.parentPage.slug}/` : ''}${item.slug}`,
                        getClassName: () => 'subtitle',
                    },
                    {
                        column: 1,
                        getValue: (item) => item.title,
                        getClassName: () => 'title',
                    },
                ]}
                actions={[
                    {
                        title: 'Edit',
                        onClick: (item) => navigate(`/edit-pages/${item.id}`),
                        icon: ICONS.EDIT_GRAY,
                    },
                ]}
            />
        </>
    )
}
